module.exports = __webpack_public_path__ + "img/SC-4999.d097a70d.png";